// extracted by mini-css-extract-plugin
export default {"Locations":"Locations_Locations__PsHcl","Locations__new":"Locations_Locations__new__7OXqx","Locations__table":"Locations_Locations__table__OmHig"};